export const vsName = "conversionModal";
export const vsServiceName = "conversionModalService";
